import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12;
let PlanModel = (_dec = attr('string'), _dec2 = attr('boolean'), _dec3 = attr('number'), _dec4 = attr('boolean'), _dec5 = attr('number'), _dec6 = attr('number'), _dec7 = attr('number'), _dec8 = attr('number'), _dec9 = attr('boolean'), _dec0 = attr('number'), _dec1 = attr('boolean'), _dec10 = attr('number'), _dec11 = attr('boolean'), _dec12 = attr('boolean', {
  defaultValue: false
}), _class = class PlanModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "trial", _descriptor2, this);
    _initializerDefineProperty(this, "max_agents", _descriptor3, this);
    _initializerDefineProperty(this, "active", _descriptor4, this);
    _initializerDefineProperty(this, "per_agent_cost_with_annual_billing", _descriptor5, this);
    _initializerDefineProperty(this, "per_agent_cost_with_monthly_billing", _descriptor6, this);
    _initializerDefineProperty(this, "annual_billing", _descriptor7, this);
    _initializerDefineProperty(this, "monthly_billing", _descriptor8, this);
    _initializerDefineProperty(this, "can_edit_role", _descriptor9, this);
    _initializerDefineProperty(this, "max_custom_fields", _descriptor0, this);
    _initializerDefineProperty(this, "can_edit_custom_reminders", _descriptor1, this);
    _initializerDefineProperty(this, "max_disk_usage", _descriptor10, this);
    _initializerDefineProperty(this, "add_agents_available", _descriptor11, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor12, this);
  }
  get canSelectAnnual() {
    return this.annual_billing || this.per_agent_cost_with_annual_billing ? true : false;
  }
  get canSelectMonth() {
    return this.monthly_billing || this.per_agent_cost_with_monthly_billing ? true : false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "trial", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "max_agents", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "active", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "per_agent_cost_with_annual_billing", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "per_agent_cost_with_monthly_billing", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "annual_billing", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "monthly_billing", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "can_edit_role", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "max_custom_fields", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "can_edit_custom_reminders", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "max_disk_usage", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "add_agents_available", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { PlanModel as default };
//# sourceMappingURL=plan.js.map
